import LiquidCoolingImg from '../../Images/LiquidCoolingImg.jpg'

export default function Cooling(props) {
    return (
        <div style={{marginTop: '10px', marginLeft:'0px', border: '3px', padding:'40px', borderStyle:'solid', borderColor:'grey'}}>
               {/* <SectionTitle title={props.topicId}/> */}
               <h1>Cooling Systems</h1>
               <p>
               <h2>Intro to Liquid Cooling Systems;</h2>
                        Cooling systems use either air or liquid to remove or absorb heat out of a system. An easy way to keep a
                         mechanism cool is by rapidly blowing air into it using an electric fan. For heavier duty applications,
                          liquid coolant can be circulated electronically around components that need thermal protection.                    
                          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                    <img src={LiquidCoolingImg} alt="liquid cooling system" width="55%"/>
                                </div>
                        </p>
            </div>
    )
}